import { Injectable } from '@angular/core';
import moment from 'moment';
import { BehaviorSubject } from 'rxjs';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Injectable({
  providedIn: 'root',
})
export class FollowUpService {
  private followUpList = new BehaviorSubject<any[]>([]);
  followUps$ = this.followUpList.asObservable(); // Expose tasks as observable

  constructor(
    private localStorage: LocalStorageService
  ) { }

  setFollowUpList(data: any[]) {
    this.followUpList.next(data);
  }

  addFollowUp(newFollowUp: any) {

    let newFollowUpObj: any = {
      name: this.localStorage.getProfileName(),
      date: moment(newFollowUp.createdAt).format('DD/MM/YYYY HH:mm'),
      desc: `${newFollowUp.followup_mode} - ${newFollowUp.followup_status} on ${moment(newFollowUp.followup_date).format('DD/MM/YYYY')}`,
      id: newFollowUp.id,
      restData: newFollowUp
    }

    this.followUpList.next([newFollowUpObj, ...this.followUpList.value]);
  }

}
